import React from 'react';
import Bugsnag from '@bugsnag/js'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.log(error, info);
    this.setState({ hasError: true });
    Bugsnag.notify(error)
  }

  render() {
    if (this.state.hasError) return this.props.content || <h1>Something went wrong.</h1>;

    if (this.props.children !== undefined) return this.props.children;

    return null;
  }
}

export default ErrorBoundary;
